export default function Packages() {
  return (
    <section id="pacotes" className="bg-[#0A0A0A] py-16 md:py-32 lg:py-44">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="font-serif text-4xl md:text-5xl font-light text-white text-center mb-12 md:mb-16 lg:mb-24">
          Experiências
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          {/* Pacote 1 - Coquetelaria Clássica */}
          <div className="bg-black border border-[#D4AF37] p-8 md:p-12 lg:p-16">
            <p className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] mb-6 md:mb-8">
              Pacote 01
            </p>
            <h3 className="font-serif text-3xl md:text-4xl font-light text-white mb-10 md:mb-12 lg:mb-16">
              Coquetelaria Clássica
            </h3>
            
            <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-8 md:mb-10 lg:mb-12"></div>

            <div className="mb-8 md:mb-10 lg:mb-12">
              <p className="text-[#999999] text-sm font-normal mb-4 md:mb-5">Indicado para</p>
              <ul className="space-y-3 md:space-y-4">
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Casamentos
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Aniversários sofisticados
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Eventos corporativos
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Formaturas
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Celebrações elegantes
                </li>
              </ul>
            </div>

            <div className="mb-10 md:mb-12 lg:mb-16">
              <p className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] mb-4 md:mb-5">Inclui</p>
              <ul className="space-y-3 md:space-y-4">
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Até 5 cocktails alcoólicos clássicos
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  1 opção não alcoólica elaborada
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Menu personalizado
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Equipe completa
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Bar linear sofisticado
                </li>
              </ul>
            </div>

            <a
              href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20proposta%20para%20Coquetelaria%20Cl%C3%A1ssica!"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full border border-[#D4AF37] text-white text-xs uppercase tracking-widest py-5 hover:bg-[#D4AF37] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              Solicitar Proposta
            </a>
          </div>

          {/* Pacote 2 - Alta Coquetelaria */}
          <div className="bg-black border-2 border-[#D4AF37] p-8 md:p-12 lg:p-16 shadow-[0_0_30px_rgba(212,175,55,0.2)]">
            <p className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] mb-6 md:mb-8">
              Pacote 02
            </p>
            <h3 className="font-serif text-3xl md:text-4xl font-light text-white mb-10 md:mb-12 lg:mb-16">
              Alta Coquetelaria Barem
            </h3>
            
            <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-8 md:mb-10 lg:mb-12"></div>

            <div className="mb-8 md:mb-10 lg:mb-12">
              <p className="text-[#999999] text-sm font-normal mb-4 md:mb-5">Indicado para</p>
              <ul className="space-y-3 md:space-y-4">
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Casamentos de alto padrão
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Eventos empresariais premium
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Aniversários exclusivos
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Eventos de posicionamento de marca
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Celebridades e empresários
                </li>
              </ul>
            </div>

            <div className="mb-10 md:mb-12 lg:mb-16">
              <p className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] mb-4 md:mb-5">Inclui</p>
              <ul className="space-y-3 md:space-y-4">
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Até 6 cocktails clássicos ou autorais
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  1 drink assinatura exclusivo
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  2 opções não alcoólicas premium
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Menu físico impresso premium
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Equipe ampliada
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Técnicas exclusivas: defumação, espumas, clarificação
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Equipe com uniformes exclusivos de acordo com evento
                </li>
                <li className="text-[#CCCCCC] text-sm flex items-start">
                  <span className="text-[#D4AF37] mr-3">•</span>
                  Material de Bar Personalizado
                </li>
              </ul>
            </div>

            <a
              href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20proposta%20para%20Alta%20Coquetelaria%20Barem!"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-[#D4AF37] text-black text-xs uppercase tracking-widest py-5 hover:bg-[#C4A037] transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              Solicitar Proposta
            </a>
          </div>
        </div>

        {/* Nota Soft Drinks */}
        <div className="mt-10 md:mt-14 lg:mt-16 text-center">
          <div className="inline-block border border-[#D4AF37]/40 px-8 py-5 md:px-12 md:py-6">
            <p className="text-[#CCCCCC] text-sm font-light leading-relaxed tracking-wide">
              Trabalhamos com bar de{' '}
              <span className="text-[#D4AF37] font-normal">soft drinks (sem álcool)</span>
              {' '}— consulte condições comerciais exclusivas para este serviço.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}